import { store } from '../../store';
import { selectTranslate } from '../../store/selectors/ui';
import locals from './locals/lang.json';

type TranslationTable = Record<
    string,
    Record<string, { text: string } | undefined> | undefined
>;

const translations: TranslationTable = locals;

export const getTranslation = (lang: string) => (key: string) => {
    if (!translations[key]) return key;
    const translation = translations[key][lang]
        ? translations[key][lang]
        : translations[key]['en'];
    if (translation === null || translation === undefined) {
        return key;
    }
    return translation.text;
};

export const getStoreTranslation = (key: string): string => {
    const translate = selectTranslate(store.getState());
    return translate(key) ?? '';
};

export interface IAvailableLanguage {
    key: string;
    lang: string;
}

export const availableLanguages: IAvailableLanguage[] = [
    {
        key: 'en',
        lang: 'English',
    },
];
